import { typography } from 'assets/styles'
import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
`

export const SimplePaginationContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const BaseButton = styled.button.attrs({ type: 'button' })`
    ${typography.Heading24Bold};
    border: 1px solid ${(props) => props.theme.colors.monochrome.concrete};
    padding: 6px 26px;
    color: ${(props) => props.theme.colors.monochrome.steel};
    background: ${(props) => props.theme.colors.monochrome.white};
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    &:hover:not(:disabled) {
        background: ${(props) => props.theme.colors.monochrome.smoke};
    }
`

interface ArrowProps {
    $direction: 'left' | 'right'
    disabled?: boolean
}

export const Arrow = styled(BaseButton)<ArrowProps>`
    border-radius: ${({ $direction }) =>
        $direction === 'right' ? '0 40px 40px 0' : '40px 0 0 40px'};

    svg {
        fill: ${(props) =>
            props.disabled
                ? props.theme.colors.monochrome.concrete
                : props.theme.colors.brand.primary};
    }
`

export const PageIndicator = styled.div`
    ${typography.Heading24Bold};
    border-top: 1px solid ${(props) => props.theme.colors.monochrome.concrete};
    border-bottom: 1px solid
        ${(props) => props.theme.colors.monochrome.concrete};
    padding: 6px 26px;
    color: ${(props) => props.theme.colors.monochrome.steel};
    background: ${(props) => props.theme.colors.monochrome.white};
    user-select: none;
`
